<template>
    <div>
        <el-button type="primary" :disabled="disabled" @click="formDialogVisible=true">{{fName+'表单'}}</el-button>
        <el-dialog :title="fName+'表单编辑'" width="1000px" :visible="formDialogVisible" :modal="false"
                   :close-on-click-modal="false" @close="closeDialog">
            <el-form label-width="120px">
                <el-form-item label="表单标题：">
                    <el-input placeholder="请输入标题" maxlength="500" v-model="formData.name" style="width: 80%"></el-input>
                </el-form-item>
                <el-form-item label="表单说明：" style="margin-top: 20px">
                    <el-input v-model="formData.desc" type="textarea" :rows="2" placeholder="请输入说明"
                              style="width:80%"></el-input>
                </el-form-item>
                <el-form-item label="表单：" style="margin-top: 20px">
                    <div v-for="item in formData.formData" :key="item.id" style="margin-bottom: 10px">
                        <div>
                            <el-checkbox v-model="item.must" style="margin-right: 10px">必答</el-checkbox>
                            <el-input placeholder="请输入题目" maxlength="500" v-model="item.title"
                                      style="width: 460px"></el-input>
                            <el-select v-model="item.answerType" placeholder="请选择回答方式" style="width: 150px">
                                <el-option v-for="aType in formAnswerType" :key="aType.code" :label="aType.label"
                                           :value="aType.value"></el-option>
                            </el-select>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       @click="deleteForm(item.id)">删除表单
                            </el-button>
                        </div>

                        <div v-if="item.answerType=='RADIO' || item.answerType=='CHECKBOX'">
                            <div v-for="option in item.option" :key="option.id"
                                 style="margin-top: 10px">
                                <el-input placeholder="序号" maxlength="10" v-model="option.tag"
                                          style="width: 100px"></el-input>
                                <el-input placeholder="请输入选项" maxlength="500" v-model="option.content"
                                          style="width: 425px"></el-input>

                                <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                           @click="deleteOption(item.option,option.id)">删除选项
                                </el-button>
                            </div>
                            <el-button style="margin-left: 0px;margin-top: 10px" icon="el-icon-plus" type="primary"
                                       @click="addOption(item.option)">添加选项
                            </el-button>
                        </div>
                    </div>
                    <el-button style="margin-left: 0px;margin-top: 10px" icon="el-icon-plus" type="primary"
                               @click="addForm">添加表单
                    </el-button>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <div style="width: 100%;text-align: center">
                    <el-button @click="formDialogVisible=false">取消</el-button>
                    <el-button type="danger" @click="handleSave()">保存</el-button>
                </div>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    import {FORM_ANSWER_TYPE} from "../constants";

    export default {
        name: "FormData",
        props: ['value', 'fName', 'disabled'],
        data() {
            return {
                formDialogVisible: false,
                formData: this.value ? this.value : {
                    name: "",
                    desc: "",
                    formData: [{
                        id: (new Date()).getTime(),
                        title: "",
                        must: false,
                        answerType: "",
                        userAnswer: "",
                        correctAnswer: "",
                        option: [{id: (new Date()).getTime(), tag: "", content: ""}]
                    }]
                },
                formDataRules: {},
                formAnswerType: FORM_ANSWER_TYPE
            }
        },
        watch: {
            value: {
                handler(newName, oldName) {
                    this.formData = newName;
                },
                deep: true
            },
            formData: {
                handler(newName, oldName) {
                    this.$emit('change', newName);
                    this.$emit('input', newName);
                },
                deep: true
            }
        },
        methods: {
            handleSave() {
                this.$emit('change', this.formData);
                this.formDialogVisible = false;
            },
            closeDialog() {
                this.formDialogVisible = false;
            },
            addForm() {
                this.formData.formData.push({
                    id: (new Date()).getTime(),
                    title: "",
                    must: false,
                    answerType: "",
                    userAnswer: "",
                    correctAnswer: "",
                    option: [{id: (new Date()).getTime(), tag: "", content: ""}]
                });
            },
            deleteForm(id) {
                for (let i = 0; i < this.formData.formData.length; i++) {
                    if (this.formData.formData[i].id == id) {
                        this.formData.formData.splice(i, 1);
                        return;
                    }
                }
            },
            addOption(option) {
                option.push({id: (new Date()).getTime(), tag: "", content: ""});
            },
            deleteOption(option, id) {
                for (let i = 0; i < option.length; i++) {
                    if (option[i].id === id) {
                        option.splice(i, 1);
                        return;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>